const ITEMS = [
  "Landscape Design",
  "Hardscaping",
  "Irrigation Systems",
  "Tree Services",
  "Artificial Turf",
  "Sod Installation",
  "Gardening & Maintenance",
];

const MarqueeItem = ({ label }) => (
  <span className="flex items-center gap-3">
    <span className="w-1.5 h-1.5 bg-[#4ade80] rounded-full" />
    {label}
  </span>
);

export const ServicesMarquee = () => (
  <section
    className="bg-[#1f281e] text-[#faf8f5] py-5 border-y border-[#1f281e] overflow-hidden"
    aria-label="Services Ticker"
    data-testid="services-marquee"
  >
    <div className="mq-track flex items-center gap-12 font-bold uppercase tracking-widest text-xs">
      {ITEMS.map((label) => (
        <MarqueeItem key={`a-${label}`} label={label} />
      ))}
      {ITEMS.map((label) => (
        <MarqueeItem key={`b-${label}`} label={label} />
      ))}
    </div>
  </section>
);
